module.exports = __webpack_public_path__ + "static/media/pwa.9f3e24c9.png";